import { NavigateFunction } from "react-router-dom"
import requests from "../api/client"

interface SuccessfullyPaidProps {
  cartId: string
  clientId?: string | number
  virtualChip: boolean
  navigate: NavigateFunction
}

export default async function SuccessfullyPaid({ cartId, clientId, virtualChip, navigate }: SuccessfullyPaidProps) {
  try {
    await requests.cartUpdate(cartId)
  } catch (error) {
    console.error("Erro ao atualizar o carrinho:", error)
  }
  
  const chipType = virtualChip ? 'A' : 'L'
  navigate(`/configure-sua-conta?id=${clientId}&tipo=${chipType}`)
}